<template>
  <div class="region">
    <p>Region:</p>
    <label>
      <input type="radio" v-model="region" value="NA">
      <span class="radio__label">North America</span>
    </label>

    <label>
      <input type="radio" v-model="region" value="EU">
      <span class="radio__label">Europe</span>
    </label>
  </div>
</template>

<script>

export default {
  name: 'Region',
  data() {
    return {
      regionData: ''
    }
  },
  mounted() {
    this.regionData = this.$route.params.region
    this.$store.commit('Region/SET_REGION', this.regionData)
  },
  computed: {
    region: {
      get() {
        return this.$store.state.Region.region
      },
      set(val) {
        this.$store.commit('Region/SET_REGION', val)
      }
    },
    currentPath() {
      return this.$route.name
    }
  },
  watch: {
    region(newVal) {
      // console.log(newVal)
      // console.log(this.$route);
      if (newVal != this.$route.params.region) {
        if (this.$route.name == 'breakdown') {
          this.$router.push({ name: 'map-your-meal', params: { region: newVal }})
        } else {
          this.$router.push({ name: this.currentPath, params: { region: newVal }})
          // and reset Quiz
          this.$store.dispatch('DietImpact/resetQuizState', null, {root: true})
        }
      }

      if (this.$store.state.menuShown) {
        this.$store.commit('TOGGLE_MENU_SHOWN')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../assets/styles/vars';
  .region {
    margin-bottom: 34px;
    display: flex;
    align-items: center;
    flex-flow: row;
    p {
      margin-right: 20px;
      margin-bottom: 0;
      color: $cWhite;
    }
    label {
      position: relative;
      margin-right: 20px;
      cursor: pointer;
      transition: opacity 0.3s ease-in;
      &:hover {
        opacity: 0.95;
        transition: opacity 0.3s ease-in;
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
    input {
      opacity: 0;
      position: absolute;
      outline: none;
      z-index: -1;
      &:checked + .radio__label:after {
        transform-origin: 50% 50%;
        transform: scaleX(1);
        transition: all 0.2s ease-in;
      }
    }
    .radio__label {
      font-family: $fSecondary;
      font-weight: $fwMed;
      color: $cWhite;
      font-size: 14px;
      line-height: 21px;
      text-transform: uppercase;
      &:after {
        content: "";
        width: 100%;
        height: 2px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -6px;
        background: $cWhite;
        transform-origin: 50% 50%;
        transform: scaleX(0);
        transition: all 0.2s ease-in;
      }
    }
  }
</style>
